import { Component, ViewChild, Input } from '@angular/core';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'pershing-tooltip',
  templateUrl: 'pershing-tooltip.component.html'
})
export class PershingTooltipComponent  {
@Input() displayValue: string;
@Input() triggerEvent: string;
@Input() className ?: string = 'text-link';
@ViewChild(MatMenu, { static: false }) menu: MatMenu;
@ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;

openToolTip() {
  this.trigger.openMenu();
}
closeToolTip() {
  this.trigger.closeMenu();
}
}
